import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import authService from '../services/authService';

// Entry point for links from other tools (e.g. Sage QC's Inspection button):
// /inspect?room=<session>. Signed-in reviewers go straight to the session; everyone else is
// signed in with SSO first and then sent there.
function InspectRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();
  const [message, setMessage] = useState('Opening your inspection session…');
  const ran = useRef(false);

  useEffect(() => {
    if (loading || ran.current) return;
    ran.current = true;

    const room = searchParams.get('room') || '';
    if (!/^[A-Za-z0-9_-]{1,64}$/.test(room)) {
      setMessage('This session link is not valid.');
      return;
    }
    const target = `/appraiser?room=${encodeURIComponent(room)}`;

    if (isAuthenticated) {
      navigate(target, { replace: true });
      return;
    }

    (async () => {
      try {
        if (!(await authService.getSSOStatus())) {
          navigate('/login', { replace: true });
          return;
        }
        await authService.startSSO(target);
      } catch (err) {
        setMessage('Could not start sign-in. Please try again.');
      }
    })();
  }, [loading, isAuthenticated, searchParams, navigate]);

  return (
    <div className="page">
      <header>
        <img className="logo" src="/logo.png" alt="Stewart Valuation Intelligence" />
        <h1>Remote Inspection</h1>
      </header>
      <main className="main">
        <div className="card" style={{ maxWidth: '450px', textAlign: 'center' }}>
          <h2>Inspection</h2>
          <p style={{ color: '#64748b' }}>{message}</p>
        </div>
      </main>
    </div>
  );
}

export default InspectRedirect;
